import {SearchApiResponse} from "@/types/api/search";

export class AdvancedSearchService {
    async advancedSearch(search: string): Promise<SearchApiResponse> {
        try {
            const response = await fetch(`https://search.elanza.com/api/v1/elastic-search?q=${encodeURIComponent(search)}`);
            if (!response.ok) {
                throw new Error(`API Error: ${response.statusText}`);
            }
            const data: SearchApiResponse = await response.json();
            return data;
        } catch (error) {
            console.error("AdvancedSearchService Error:", error);
            throw error; // Rethrow the error to handle it in the calling code.
        }
    }
}
